export function getDefaultAdaptableFormData(formDef) {
    return (formDef.fields || []).flat().reduce((data, field) => {
        var _a;
        data[field.name] = (_a = field.defaultValue) !== null && _a !== void 0 ? _a : '';
        return data;
    }, {});
}
